import getLocale from '@/config/get-locale'
import { getUrlParameter } from '@/helpers/url'

const href = window.location.href
const locale = getLocale(href)

const numbersRegex = /\d+/g

// Overriding Segment's default properties read from <link rel="canonical">
// DCO-4701 changed this to always point to /uk/ on purpose
const pageContext = {
  page: {
    path: window.location.pathname,
    url: window.location.href
  }
}

export function track (payload = {}) {
  const HAS_REDIRECT = getUrlParameter('redirect')
  const IS_ASSESMENT = HAS_REDIRECT && HAS_REDIRECT.includes('/assessment/')
  let assessmentConfig = {}

  if (IS_ASSESMENT) {
    const assessmentServiceId = HAS_REDIRECT.split('/assessment/')[1].match(numbersRegex)
    assessmentConfig = {
      service_id: assessmentServiceId[0],
      step: 'auth',
      screen: 'assessment'
    }
  }

  const params = {
    screen_height: window.screen.height,
    screen_width: window.screen.width,
    locale,
    screen: 'account', // Gets replaced by assessment if assessment
    ...payload.params,
    ...assessmentConfig
  }

  if (payload.name === 'page view') {
    return window.analytics.page('', { ...params, path: pageContext.page.path, url: pageContext.page.url }, pageContext)
  } else {
    return window.analytics.track(payload.name, params, pageContext)
  }
}

// Map m/f to male/female for gender in payload
export function mapGender (payload) {
  if (payload.hasOwnProperty('gender')) {
    const genderMap = {
      m: 'male',
      f: 'female'
    }

    payload.gender = genderMap[payload.gender] ? genderMap[payload.gender] : payload.gender

    // Send error if gender invalid
    if (!Object.values(genderMap).includes(payload.gender)) {
      if (window.newrelic) {
        window.newrelic.noticeError(new Error('Invalid gender value'))
      }
    }
  }
  return payload
}

export function identify (userId = null, payload = {}, createdAt = new Date().toISOString()) {
  if (window.analytics) {
    let params = mapGender(payload)

    if (createdAt) {
      params = {
        ...params,
        locale
      }

      if (userId) {
        params = {
          ...params,
          createdAt
        }
      }
    }

    window.analytics.identify(userId, params, pageContext)
  }
}
